import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  heroImageAlt: {
    id: 'portal.views.courseCatalogue.heroImage.alt',
    defaultMessage: 'Modules list hero image',
    description: 'Alt text for modules list hero image',
  },
  heading: {
    id: 'portal.views.courseCatalogue.hero.heading',
    defaultMessage: '<lead>A journey of</lead>{br}<tail>Self Discovery</tail>',
    description: 'Hero heading: <lead> and <tail> are two lines in two typefaces; a locale may keep only <tail> for one line',
  },
  catalogueIntro: {
    id: 'portal.views.courseCatalogue.intro',
    defaultMessage: 'Unleash your leadership potential with purpose, courage, love, and hope. '
      + 'Dive deep in interactive modules and apply your learning through practical 5-day challenges. '
      + 'Elevate your leadership to build a better world.',
    description: 'Unleash your leadership potential description',
  },
});

export default messages;
